/* eslint-disable max-len */
import { Variants } from 'framer-motion';
import React, { useMemo } from 'react';
import { fuzzySearch, useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { WorkspaceModel } from '../Models';
import { Flexer } from '../elements/LayoutElements';
import { FolderListContext, FolderListItem } from './FolderListItem';

const nextAnimation: Variants = {
    before: {
        opacity: 0,
    },
    in: {
        opacity: 1,
        y: '0rem',
        transition: {
            duration: .2,
            ease: 'easeOut',
        }
    },
    out: {
        opacity: 0,
        scale: 0.5,
        transition: {
            duration: .2,
            ease: 'easeOut',
        }
    }
};

export const FolderListView = React.memo<{ search: string }>(({ search }) => {

    const workspace = useObserver(useResolve(WorkspaceModel));
    const folders = useMemo(() => {
        return fuzzySearch({
            items: workspace.folders,
            keys: ['label'],
            search,
        });
    }, [workspace.folders, search]);

    if (!folders.length) {
        return null;
    }

    return <FolderListContext.Provider value={{ baseUrl: `~/${workspace.id}/boards` }}>
        <Flexer margin="0 0 2 0">
            <Flexer flex="column" gap="2">
                <Flexer flex="row" wrap="wrap" gap="2">
                    {folders.map(x => <FolderListItem key={x.id} folder={x} />)}
                </Flexer>
            </Flexer>
        </Flexer>
    </FolderListContext.Provider>;
});
